import React from 'react';

const Footer =()=>{
  return(
    <div className="footer">
      <small>(c)2020 札幌市 | icons from <a href='https://jp.freepik.com/free-photos-vectors/icon'>Dreamwaves</a></small>
    </div>
  )
}

export default Footer